import { HUB_PATH } from '@/lib/components/RewardsHub/routes';

// ── Header nav targets (locale-less) ──

export const LOGIN_PATH = '/auth/login';
export const SIGNUP_PATH = '/auth/signup';
export const BUY_CRYPTO_PATH = '/buy-crypto';
export const POSITIONS_PATH = '/account?tab=deals&dealsTab=openPositions';
export const HISTORY_PATH = '/account?tab=deals&dealsTab=orderHistory';
export const REFERRALS_PATH = '/account?tab=referrals';
export const CLAIM_PATH = `${HUB_PATH}#ready-to-claim`;

// ── Futures (a kind's row opens its BTC pair; the mega menu's list picks any other) ──

export const USDT_FUTURES_PATH = '/trade/usdt/BTCUSDT';
export const USDC_FUTURES_PATH = '/trade/usdc/BTCUSDC';
export const COIN_FUTURES_PATH = '/trade/inverse/BTCUSD';
/** Opens on the Open positions tab. */
export const FUTURES_POSITIONS_PATH = '/trade/deals';

// shortcut: /card has no page yet and 404s until the card landing ships.
export const CARD_PATH = '/card';
